import { SuperDialog, SuperDialogProps } from "@components:SuperDialog";
import Typography from "@mui/material/Typography";

type ConfirmationDialogProps = {
  title: string;
  description: string;
  open: boolean;
  onClose: () => void;
  actionControls: SuperDialogProps["actionControls"];
};

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const { title, description, open, onClose, actionControls } = props;

  return (
    <SuperDialog
      titlePlacement="start"
      sx={{
        "& .MuiDialog-paper": {
          maxHeight: 435,
        },
      }}
      open={open}
      onClose={onClose}
      title={title}
      actionControls={actionControls}
    >
      <Typography variant="body1">{description}</Typography>
    </SuperDialog>
  );
}
